import { Theme } from "@material-ui/core/styles";
import { createStyles, makeStyles } from "@material-ui/styles";
import { Button, Paper } from "@material-ui/core";
import React from "react";
import { PaymentMethodType } from "./PaymentConstants";
import TranslatedMessage from "../translations/TranslatedMessage";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      height: "100%",
    },
    item: {
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: theme.spacing(1) + "px",
      height: theme.spacing(16),
      width: theme.spacing(23),
    },
    text:{
      textWrap: "wrap",
      height: "100%",
    }
  })
);

type PaymentMethodItemProps = {
  selected: PaymentMethodType | undefined;
  type: PaymentMethodType;
  label?: string;
  icon: any;
  onSelect: (type: PaymentMethodType) => void;
};

const PaymentMethodItem: React.FC<PaymentMethodItemProps> = ({
  selected,
  icon,
  type,
  onSelect,
}: PaymentMethodItemProps) => {
  const classes = useStyles();
  if (selected !== undefined && selected !== type) {
    return null;
  }

  return (
    <Button onClick={() => onSelect(type)} className={classes.button}>
      <Paper className={classes.item}>
        <div>{icon}</div>
        <div className={classes.text}>{type === PaymentMethodType.CembraPay ? <TranslatedMessage id="paymentMethodSelector.item.invoice" /> : <TranslatedMessage id="paymentMethodSelector.item.creditCard" />}</div>
        {type === PaymentMethodType.CembraPay && <div><TranslatedMessage id="paymentMethodSelector.item.invoiceMessage" /></div>}
      </Paper>
    </Button>
  );
};

export default PaymentMethodItem;
